(function($) {
  // Helper to fetch product data JSON from DOM
  function getProductData($form) {
    var productId = $form.data("product-id");
    var el = document.getElementById("product-data-" + productId);
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch(e) {
      console.warn("Failed to parse product JSON", e);
      return null;
    }
  }

  // Push variant info (and store globally)
  function pushVariant($form, trigger) {
    var productData = getProductData($form);
    if (!productData) return;

    var variantId = $form.find('[name="id"]').val();
    var variant = productData.variants.find(function(v) {
      return v.id == variantId;
    });

    if (!variant) {
      console.warn("No variant found for id", variantId);
      return;
    }

    var payload = {
      event: "variantChange",
      trigger: trigger,
      product: {
        id: productData.id,
        title: productData.title,
        handle: productData.handle,
        type: productData.type,
        tags: productData.tags,
        collections: productData.collections,
        brand: productData.brand,
        featured_image: productData.featured_image,
        currency: productData.currency
      },
      variant: variant
    };

    // Store globally so Add to Cart can use it
    window.currentSelectedVariant = payload;

    console.log("[Variant Debug]", payload);
  }

  // Handle Add to Cart
  function handleAddToCart(e) {
    if (!window.currentSelectedVariant) {
      console.warn("No variant selected for Add to Cart");
      return;
    }

    var payload = window.currentSelectedVariant;

    var item = {
      Name: payload.product.title,
      URL: window.location.href,
      SKU: payload.variant.sku,
      ImageURL: payload.variant.featured_image 
        ? payload.variant.featured_image.src || payload.variant.featured_image
        : payload.product.featured_image,
      Price: Shopify.formatMoney(payload.variant.price),
      CompareAtPrice: Shopify.formatMoney(payload.variant.compare_at_price || null),
      Brand: payload.product.brand,
      StyleNumber: payload.product.type,
      Tags: payload.product.tags,
      Collections: payload.product.collections,
      Currency: payload.product.currency,
      VariantId: payload.variant.id,
      VariantTitle: payload.variant.title
    };

    var _learnq = window._learnq || [];
    _learnq.push(["track", "Added to Cart", item]);

    console.log("[AddToCart Debug]", item);

  }

  // =====================
  // Event Listeners
  // =====================

  // On page load
  $(document).ready(function() {
    $(".product_form").each(function() {
      pushVariant($(this), "ready");
    });
  });

  // On Shopify’s variant change event
  $(document).on("variant:changed", ".product_form", function(evt, variant) {
    console.log('Variant Changed 1');
    pushVariant($(this), "change:event");
  });

  // Fallback: whenever a variant selector changes
  $("body").on("change", "[data-variant-selector], .single-option-selector", function () {
    console.log('Variant Changed 2');
    pushVariant($(this).closest(".product_form"), "change:fallback");
  });

  // Add to Cart — listen to both ID and Class separately
  $(document).on("click", "#pd-add-to-cart", handleAddToCart);
  $(document).on("click", ".checkmark", handleAddToCart);

})(jQuery);


